import { render, staticRenderFns } from "./TableEndorsementMovement.vue?vue&type=template&id=2f5d9b00&scoped=true&"
import script from "./TableEndorsementMovement.vue?vue&type=script&lang=js&"
export * from "./TableEndorsementMovement.vue?vue&type=script&lang=js&"
import style0 from "./TableEndorsementMovement.vue?vue&type=style&index=0&id=2f5d9b00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d9b00",
  null
  
)

export default component.exports